<template>
  <v-container fluid grid-list-sm>
    <v-row>
      <v-col cols="12" sm="9">
        <h3 class="display-1 primary--text">Admin</h3>
      </v-col>
      <v-col cols="12" sm="3">
        <v-btn @click="connectToXero" text large width="200" >
          <v-img :src="require('../assets/connect-blue.svg')" width="200" contain />
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12">
        <v-btn to="/week" color="primary">Week Sheets</v-btn>
        <v-btn class="ml-3" to="/commission" color="primary">Commission Report</v-btn>
        <v-btn class="ml-3" to="/annual" color="primary">Annual Turnover Report By Technician</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    export default {
        name: "Admin",
        methods: {
            connectToXero() {
                window.location.href = '/api/xero/auth'
            }
        }
    }
</script>
